/**
 * infinite-scroll.js — Infinite scroll for collection grids.
 * Uses IntersectionObserver + Section Rendering API.
 * Depends on: utils.js (fetchSection)
 */

(function () {
  var grid = document.getElementById('CollectionProductGrid');
  if (!grid) return;

  var wrapper = grid.closest('.shopify-section');
  var sectionId = wrapper && wrapper.id
    ? wrapper.id.replace(/^shopify-section-/, '')
    : null;
  if (!sectionId) return;

  var loading = false;
  var observer = null;

  function getInnerGrid(container) {
    return container.querySelector('.grid');
  }

  function init() {
    var sentinel = document.getElementById('CollectionInfiniteScroll');
    if (!sentinel) return;

    if (observer) observer.disconnect();

    observer = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting && !loading) {
          loadMore(sentinel);
        }
      },
      { rootMargin: '400px' }
    );

    observer.observe(sentinel);
  }

  async function loadMore(sentinel) {
    var nextUrl = sentinel.getAttribute('data-next-url');
    if (!nextUrl) return;

    loading = true;
    var spinner = sentinel.querySelector('.infinite-scroll-spinner');
    if (spinner) spinner.classList.remove('hidden');

    try {
      var data = await fetchSection(nextUrl, [sectionId]);
      var html = data[sectionId];
      if (!html) return;

      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');

      // Extract new product cards from the fetched grid
      var newGrid = doc.querySelector('#CollectionProductGrid .grid');
      if (newGrid) {
        var currentGrid = getInnerGrid(grid);
        if (currentGrid) {
          // Append each new card to the existing grid
          var fragment = document.createDocumentFragment();
          Array.from(newGrid.children).forEach(function (child) {
            fragment.appendChild(child.cloneNode(true));
          });
          currentGrid.appendChild(fragment);

          // Re-observe animations on new elements
          if (typeof reobserveAnimations === 'function') {
            reobserveAnimations(currentGrid);
          }
        }
      }

      // Check if there's a next page in the fetched HTML
      var newSentinel = doc.querySelector('#CollectionInfiniteScroll');
      if (newSentinel && newSentinel.getAttribute('data-next-url')) {
        sentinel.setAttribute('data-next-url', newSentinel.getAttribute('data-next-url'));
        sentinel.setAttribute('data-current-page', newSentinel.getAttribute('data-current-page'));
      } else {
        // No more pages — remove sentinel and stop observing
        if (observer) observer.disconnect();
        sentinel.remove();
      }
    } catch (err) {
      console.error('Infinite scroll load failed:', err);
    }

    loading = false;
    if (spinner) spinner.classList.add('hidden');
  }

  // Initialize on page load
  init();

  // Re-initialize after filter/sort changes (dispatched by collection.js)
  document.addEventListener('collection:updated', function () {
    loading = false;
    init();
  });
})();
